var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.noticeText.length)?_c('div',{staticClass:"notice"},[_vm._v("\n    直播间公告："+_vm._s(_vm.noticeText)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }